declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: () => void;
  }
}

class LazyloadVideo {
  private overlay: HTMLElement | null;
  private player: any = null;

  constructor() {
    this.overlay = document.querySelector('.video-overlay');

    this.loadYouTubeAPI();
  }

  private loadYouTubeAPI(): void {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
  }

  private onYouTubeIframeAPIReady(): void {
    const iframe = document.getElementById(
      'youtube-player'
    ) as HTMLIFrameElement;

    this.player = new window.YT.Player(iframe, {
      events: {
        onReady: this.onPlayerReady.bind(this)
      }
    });
  }

  private onPlayerReady(): void {
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        // Bloque le scroll automatique
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        const preventScroll = () => {
          window.scrollTo(scrollX, scrollY);
        };
        window.addEventListener('scroll', preventScroll);
        setTimeout(
          () => window.removeEventListener('scroll', preventScroll),
          1000
        );

        // Lance la vidéo
        if (this.player?.playVideo) {
          this.player.playVideo();
        }

        // Retire l'overlay pour libérer l'accès à l'iframe
        this.overlay?.remove();
      });
    }
  }
}

export const lazyloadVideo = new LazyloadVideo();
